import { Component } from 'react';
import PropTypes from 'prop-types';

import { hasAccess, hasFeatureEnabled } from '../utils/AccessControlUtil';

/**
 * Shows/hides or displays alternate content based on whether a set
 * of conditions is met.  If more than one set of conditions is provided,
 * then all conditions must pass to show the content
 */
export class AccessControlWrapper extends Component {
  static propTypes = {
    /** feature props */
    flag: PropTypes.string,
    adminifiUrl: PropTypes.string,
    authToken: PropTypes.string,
    /** generic value required to view content */
    // requiredValue: PropTypes.oneOfType([
    //   PropTypes.string, PropTypes.arrayOf(PropTypes.string)
    // ]),
    /** permission required to view content (taken from admin) */
    // requiredPermission: PropTypes.string,
    /** business line required to view content - if array only one needs
    to match (taken from user if provided, otherwise taken from organization) */
    // requiredBusinessLine: PropTypes.oneOfType([
    //   PropTypes.string, PropTypes.arrayOf(PropTypes.string)
    // ]),
    /** capability required to view content (taken from organization) */
    // requiredCapability: PropTypes.string,
    /** organizationType required to view content (taken from organization) */
    // requiredOrganizationType: PropTypes.oneOf(['advanced', 'basic']),
    /** values available */
    // values: PropTypes.arrayOf(PropTypes.string),
    /** permissions available */
    // permissions: PropTypes.arrayOf(PropTypes.string),
    /** business lines available */
    // businessLines: PropTypes.arrayOf(PropTypes.string),
    /** capabilities available */
    // capabilities: PropTypes.arrayOf(PropTypes.string),
    /** organization type */
    // organizationType: PropTypes.oneOf(['advanced', 'basic']),
    /** will search admin for permissions */
    admin: PropTypes.shape({
      permissions: PropTypes.arrayOf(PropTypes.string),
    }),
    /** will search user for businessLines */
    user: PropTypes.shape({
      business_lines: PropTypes.arrayOf(PropTypes.string),
    }),
    /** will search org for capabilities/organization_type */
    organization: PropTypes.shape({
      capability_list: PropTypes.arrayOf(PropTypes.string),
      organization_type: PropTypes.oneOf(['advanced', 'basic']),
    }),
    /** renders children if flipper check passes */
    children: PropTypes.node,
    /** renders alternateContent if flipper check fails */
    alternateContent: PropTypes.node,
  };

  constructor(props) {
    super(props);

    this.state = {
      featureEnabled: !props.flag,
    };
  }

  async componentDidMount() {
    const { flag, adminifiUrl, authToken } = this.props;
    if (flag) {
      const featureEnabled = await hasFeatureEnabled(flag, adminifiUrl, authToken);
      this.setState({ featureEnabled });
    } else {
      this.setState({ featureEnabled: true });
    }
  }

  hasAccess = () => {
    return hasAccess(this.props) && this.hasFeatureEnabled();
  };

  hasFeatureEnabled = () => this.state.featureEnabled;

  render() {
    if (this.hasAccess()) {
      return this.props.children;
    }
    return this.props.alternateContent || null;
  }
}
